import { useId } from 'react';
import { Checkbox, FormLabel } from '@mui/material';
import cn from 'classnames';

import { Tooltip } from '../tooltip';

import './labelAction.css';

export interface ILabelCheckbox {
  classname?: string;
  value?: boolean;
  checkedIcon?: React.ReactNode;
  uncheckedIcon?: React.ReactNode;
  checkedTooltip?: string;
  uncheckedTooltip?: string;
  onChange?: (val: boolean) => void;
  disabled?: boolean;
  label?: React.ReactNode;
  name?: string;
  ariaLabel?: string;
}

/**
 * Adds a configurable checkbox alongside a form label.
 */
export const LabelCheckbox: React.FC<React.PropsWithChildren<ILabelCheckbox>> = ({
  classname,
  children,
  value,
  label,
  checkedIcon,
  checkedTooltip,
  disabled,
  onChange,
  uncheckedIcon,
  uncheckedTooltip,
  name,
  ariaLabel,
}) => {
  const id = useId();
  if (value === undefined) {
    return children;
  }

  return (
    <span className={cn('seccl-label-action', classname)}>
      {children}

      <Tooltip title={value ? checkedTooltip : uncheckedTooltip}>
        <FormLabel disabled={disabled} htmlFor={id} className="seccl-radio-group-form-control-label">
          <Checkbox
            id={id}
            checked={value}
            onChange={e => onChange?.(e.target.checked)}
            icon={uncheckedIcon}
            checkedIcon={checkedIcon}
            disabled={disabled}
            inputProps={{ 'aria-label': ariaLabel }}
            size="large"
            data-testid={name}
          />
          {label}
        </FormLabel>
      </Tooltip>
    </span>
  );
};
